import SendWisetackLinkDialog from './SendWisetackLinkDialog'
export default SendWisetackLinkDialog
